import {
    GET_MAQUINA_DETALLES, ADD_NEW_MAQUINA, ADD_INCIDENCIA_MAQUINA, MODIFY_INCIDENCIA_MAQUINA, DELETE_INCIDENCIA_MAQUINA
} from '../constants/action_types';

const initialState = { maquinaIncidencias: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINA_DETALLES:

            return {
                maquinaIncidencias: [],
                isLoading: true
            };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            return {
                maquinaIncidencias: action.payload.data.incidencias,
                isLoading: false
            };


        case ADD_INCIDENCIA_MAQUINA:

            const newArr = [...state.maquinaIncidencias, action.payload]

            return {
                maquinaIncidencias: newArr,
                isLoading: false
            };

        case DELETE_INCIDENCIA_MAQUINA:

            return {
                maquinaIncidencias: state.maquinaIncidencias.filter(incidencia => incidencia.id !== action.payload.id),
                isLoading: false
            };

        case MODIFY_INCIDENCIA_MAQUINA:

            return {
                maquinaIncidencias: state.maquinaIncidencias.map((incidencia) => {
                    if (incidencia.id !== action.payload.id) return incidencia;
                    else return action.payload;
                }),
                isLoading: false
            };

        case ADD_NEW_MAQUINA:
            return initialState;

        default:

            return state;
    }

}